import { IAsyncState, MetaAction, NormalizedEndpoint, PayloadAction } from './types';

export function createNormalizedEndpoint<D = unknown, ID extends string | number = string>(
  data?: D[],
): NormalizedEndpoint<D, ID> {
  if (data) {
    const allIds: ID[] = [];
    const byId: Record<ID, D> = {} as Record<ID, D>;

    data.forEach((row: any) => {
      if (!row.id) return;

      allIds.push(row.id);
      byId[row.id as ID] = row;
    });
    return {
      allIds,
      byId,
    };
  }

  return {
    allIds: [],
    byId: {} as Record<ID, D>,
  };
}

export function createAsyncState<D = unknown>(data: D): IAsyncState<D> {
  return {
    data,
    isFetching: false,
    isUpdating: false,
  };
}

export const createAction = <Type extends string, Meta, Error>(
  type: Type,
  meta?: Meta,
  error?: Error,
): MetaAction<Type, Meta, Error> => ({ type, meta, error });

export const createPayloadAction = <Type extends string, Payload, Meta, Error>(
  type: Type,
  payload?: Payload,
  meta?: Meta,
  error?: Error,
): PayloadAction<Type, Payload, Meta, Error> => ({
  ...createAction(type, meta, error),
  payload,
});

interface Actions {
  START: string;
  SUCCESS: string;
  FAILURE: string;
}

export const actionStringGenerator = (type: string, actionName: string): Actions => ({
  START: `${type}/${actionName}_START`,
  SUCCESS: `${type}/${actionName}_SUCCESS`,
  FAILURE: `${type}/${actionName}_FAILURE`,
});
